<template>
    <div class="clickable" @click="open(item)" >
        <div class="home-app">
            <i :class="'icon bi bi-' + item.icon" v-if="hasIcon" :key="item.icon"></i>
            <h3 v-else>{{ text }}</h3>
        </div>

        <div class="name">{{ title }}</div>
    </div>
</template>

<script>
import { truncate } from 'lodash'

export default {
    props: {
        item: {
            type: Object
        }
    },

    computed: {
        text() {
            const t = this.$translateLabel(this.item.label, this.item.name)

            return t[0].toUpperCase()
        },

        hasIcon() {
            return this.item.icon
        },

        title() {
            const t = this.$translateLabel(this.item.label, this.item.name)

            if (t.includes("_")) {
                return truncate(t, {
                    length: 12,
                    ommit: '...'
                })
            }

            return t
        }
    },

    methods: {
        open(item) {
            this.$emit('open', item)
        }
    }
}
</script>

<style scoped lang="scss">
.clickable {
  text-align: center;
  cursor: pointer;
}

.home-app {
  background-color: #2F353A;
  width: 64px;
  height: 64px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-radius: 15px;
  margin: 0 auto;

  &:hover {
    box-shadow: none;
  }

  & > h3 {
    line-height: 64px;
  }

  & > .icon {
    font-size: 40px;
    margin-top: 11px;
  }
}

.name {
    text-align: center;
    font-size: 12px;
    width: 64px;
    margin: 5px auto;
}
</style>